import { Box, Grid } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

import { getMaxDate } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/getMaxDate';
import { getMinDate } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/utils/getMinDate';
import { Font } from '@/components/shared/components/Font';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const AccommodationForm = () => {
  const { getTextIdTranslation } = useTranslation();
  const { watch } = useFormContext();

  return (
    <Box width={'100%'}>
      <Font variant="h4" color="textPrimary">
        <Text strong tId={'ACCOMMODATION_DETAILS'} />
      </Font>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextFormField
            name={'item.establishmentName'}
            label={'ACCOMMODATION_NAME'}
            placeholder={getTextIdTranslation('ACCOMMODATION_NAME_PLACEHOLDER')}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateFormField
            name={'item.checkinDate'}
            label={'CHECKIN_DATE'}
            fieldVariant={FieldVariant.form}
            maxDate={getMaxDate(watch('item.checkoutDate'))}
            disablePast
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DateFormField
            name={'item.checkoutDate'}
            label={'CHECKOUT_DATE'}
            fieldVariant={FieldVariant.form}
            minDate={getMinDate(watch('item.checkinDate'))}
            disablePast
          />
        </Grid>
      </Grid>
    </Box>
  );
};
